import React, { Fragment, FunctionComponent } from 'react';

import { forTemplate } from 'app/common/lib/util/i18n';
const format = forTemplate('error');

import { HeaderSkeleton } from 'app/src/components/HeaderSkeleton';
import {
  ErrorDetails,
  ErrorHandlerProps,
} from 'app/src/components/ErrorBoundary';

export const GlobalErrorHandler: FunctionComponent<ErrorHandlerProps> = ({
  caughtError,
}) => {
  return (
    <Fragment>
      <HeaderSkeleton />
      <div style={{ padding: 20 }}>
        <h3>
          <span style={{ color: '#DE350B', marginRight: 10 }}>
            {format('global-unhandled')}
          </span>
        </h3>
        <p>{format('reload-call-to-action')}</p>
        <p>{format('contact-us')}</p>
        <ErrorDetails caughtError={caughtError} />
      </div>
    </Fragment>
  );
};
